import { useEffect, useState } from 'react';
import {
    Avatar,
    Box,
    Button,
    Flex,
    Heading,
    HStack,
    Image,
    Input,
    InputGroup,
    InputLeftElement,
    Spinner,
    Text,
    VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { OrderSection } from './components/DashboardStyles';
import { backbtn, search } from './components/Icons';
import emptyList from '../../assets/empty-list.png';
import SingleCartItem from './components/SingleCartItem';
import cartSvg from '../../assets/shopping-cart.svg';
import { useDispatch, useSelector } from 'react-redux';
import { view_cart } from '../../redux/actions/productActions';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';

const Cart = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const productReducer = useSelector((state) => state.productReducer);
    const { quoteId, cartItems, adding } = productReducer;

    const [refresh, setRefresh] = useState(1);

    useEffect(() => {
        dispatch(view_cart(quoteId));
    }, [adding, dispatch, quoteId]);
    const total =
        cartItems !== 'undefined'
            ? cartItems?.items?.reduce((a, b) => a + Number(b.price * b?.qty), 0)
            : 0;
    return (
        <>
            {cartItems ? (
                <OrderSection>
                    {cartItems?.items?.length === 0 ? (
                        <Box position="relative">
                            <HStack
                                justify="space-between"
                                py="27px"
                                px="27px"
                                gap="15px"
                                alignItems="center">
                                <InputGroup bg="#F2F4F5" border="none" borderRadius="8px" h="36px">
                                    <InputLeftElement pointerEvents="none">
                                        {search}
                                    </InputLeftElement>
                                    <Input
                                        type="phone"
                                        placeholder="Search Order ID"
                                        border="none"
                                    />
                                </InputGroup>
                                <div className="menuSection">
                                    <Avatar
                                        size="sm"
                                        name="Prosper Otemuyiwa"
                                        // src="https://bit.ly/prosper-baba"
                                    />
                                </div>
                            </HStack>

                            <HStack justify="space-between" px="27px" mt="15px" alignItems="center">
                                <Heading
                                    as="h2"
                                    textAlign="center"
                                    color="#090A0A"
                                    fontSize="32px"
                                    lineHeight="36px">
                                    My Cart
                                </Heading>
                                <Button
                                    color="#F5F5F5"
                                    bg="#1b3b5f"
                                    mt="15px"
                                    fontWeight="400"
                                    borderRadius="48px"
                                    h="32px"
                                    w="43px"
                                    outline="none"
                                    onClick={() => {
                                        navigate('/dashboard/categories');
                                    }}>
                                    +
                                </Button>
                            </HStack>

                            <VStack h="55vh" justify="center">
                                <Image src={emptyList} />
                                <Text
                                    w="200px"
                                    textAlign="center"
                                    fontWeight="600"
                                    fontSize="17px"
                                    lineHeight="16px"
                                    pt="27px">
                                    You have not added any Product to My Cart
                                </Text>
                            </VStack>
                        </Box>
                    ) : (
                        <Box
                            position="relative"
                            pb="20px"
                            w={{ base: 'full', lg: '95%' }}
                            mx="auto">
                            <HStack
                                justify="space-between"
                                alignItems="center"
                                mt="27px"
                                w={{ base: '90vw', lg: '98%' }}
                                mx="auto">
                                <Box
                                    display={{ base: 'flex', lg: 'none' }}
                                    onClick={() => navigate(-1)}>
                                    {backbtn}
                                </Box>
                                <Box
                                    display={{ base: 'block', lg: 'flex' }}
                                    alignItems="center"
                                    gap="10rem">
                                    <Flex gap="5px" justify="center">
                                        <Heading
                                            as="h2"
                                            textAlign="center"
                                            color="#090A0A"
                                            fontSize={{ base: '22px', lg: '32px' }}
                                            lineHeight="36px">
                                            My Cart
                                        </Heading>
                                        <Image src={cartSvg} />
                                    </Flex>
                                    <Text>
                                        {cartItems?.items?.length} items - Total{' '}
                                        <WalletHistoryPrice price={total} />
                                    </Text>
                                </Box>
                                <div></div>
                            </HStack>
                            <Flex
                                flexDir={{ base: 'column', lg: 'row' }}
                                w={{ base: 'full', lg: '95%' }}
                                mx="auto"
                                gap={{ base: '0', lg: '5rem' }}>
                                <VStack
                                    h="max-content"
                                    w={{ base: 'full', lg: '40%' }}
                                    gap={{ base: 0, lg: '1.3rem' }}
                                    mb="4rem">
                                    {cartItems?.items ? (
                                        cartItems?.items.map((li) => (
                                            <SingleCartItem
                                                item={li}
                                                key={li.id}
                                                quoteId={quoteId}
                                                refresh={refresh}
                                                setRefresh={setRefresh}
                                            />
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                </VStack>
                                <Box w={{ base: 'full', lg: '50%' }} mt={{ lg: '3rem', base: 0 }}>
                                    <VStack
                                        w={{ base: '80%', lg: '90%' }}
                                        mx="auto"
                                        alignItems="start">
                                        <Heading
                                            fontSize="15px"
                                            lineHeight="32px"
                                            pb="5px"
                                            w="full"
                                            mb="10px"
                                            borderBottom="1px solid #0000001a">
                                            Total
                                        </Heading>
                                        <Flex justifyContent="space-between" w="full">
                                            {' '}
                                            <Text fontSize="13px" fontWeight="700">
                                                Sub-total
                                            </Text>
                                            <Text fontSize="18px" fontWeight="700">
                                                <WalletHistoryPrice price={total} />
                                            </Text>
                                        </Flex>
                                    </VStack>
                                    <Box w="90%" mx="auto" mb="2rem">
                                        <Button
                                            color="#F5F5F5"
                                            bg="#1b3b5f"
                                            mt="15px"
                                            fontWeight="400"
                                            borderRadius={{ base: '48px', lg: '0' }}
                                            h="48px"
                                            w="full"
                                            mx="auto"
                                            outline="none"
                                            _hover={{
                                                fontWeight: '500',
                                                textDecoration: 'underline',
                                            }}
                                            onClick={() => navigate(`/dashboard/checkout`)}>
                                            Checkout
                                        </Button>
                                    </Box>
                                </Box>
                            </Flex>
                        </Box>
                    )}
                </OrderSection>
            ) : (
                <Spinner size="xl" />
            )}
        </>
    );
};

export default Cart;
